module.exports = __webpack_public_path__ + "static/img/pic_szh_zhptyy_ks_lb2@2x.08109583.jpg";